export const notificationOptions = {
	icon: '/favicon.png',
	dir: 'rtl',
	lang: 'en-US',
};

// TODO: أضف أنواع إشعارات Octopharma ومسار الانتقال لكل نوع
export const notificationPageRedirect = [];

// TODO: صفحات لا يُعرض فيها الإشعار المنبثق (مثلاً صفحة الإشعارات نفسها)
export const preventedPagesFromNotification = [];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyDL_jfDaLLi2EuhpRlHe58XPmffsgqzkSI',
		authDomain: 'octopharma-f4d59.firebaseapp.com',
		projectId: 'octopharma-f4d59',
		storageBucket: 'octopharma-f4d59.firebasestorage.app',
		messagingSenderId: '961253865724',
		appId: '1:961253865724:web:0006fc5ccac28967e4ff79'
	},
	publicKey: 'BKXNliInu0ZBwGiNc731ORPxqs19KFVO-IgH8NSi9GwI4WAq_o3NHn_H9zxZTijVQVVTb8lc6-DBLqZSeZOwwgw',
};
